var _rect, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 7.5,
    width: 15,
    height: 9.16667,
    stroke: "#8C8A94",
    strokeWidth: 1.66667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.33301H17.5V7.49967H2.5V3.33301Z",
    stroke: "#8C8A94",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 0.833008,
    width: 1.66667,
    height: 4.16667,
    fill: "#8C8A94"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 0.833008,
    width: 1.66667,
    height: 4.16667,
    fill: "#8C8A94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0ca8cc27287eccf8ee55e354e1b7e40e.svg";
export { ForwardRef as ReactComponent };